define(['handlebars'], function (handlebars) {

    return function (arg1, arg2, options) {
        return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
    }

});